import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export default function getCities(_x) {
  return _getCities.apply(this, arguments);
}
function _getCities() {
  _getCities = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stateUfNumber) {
    var route, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          route = "https://servicodados.ibge.gov.br/api/v1/localidades/estados/" + stateUfNumber + "/municipios";
          _context.next = 3;
          return fetch(route).then(function (data) {
            return data.json();
          });
        case 3:
          _context.t0 = _context.sent;
          if (_context.t0) {
            _context.next = 6;
            break;
          }
          _context.t0 = [];
        case 6:
          res = _context.t0;
          return _context.abrupt("return", res);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getCities.apply(this, arguments);
}